module.exports = __webpack_public_path__ + "img/golden-0.edddca7b.png";